var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputepic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18558_13177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 2.18896V0.439453",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57812 2.18896V0.439453",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.139 9.18701H12.3145",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.139 4.81299H12.3145",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27961 9.18701H0.455078",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27961 4.81299H0.455078",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 13.5605V11.811",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57812 13.5605V11.811",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3107 2.18896H3.28279C2.72858 2.18896 2.2793 2.61977 2.2793 3.1512V10.849C2.2793 11.3805 2.72858 11.8113 3.28279 11.8113H11.3107C11.8649 11.8113 12.3142 11.3805 12.3142 10.849V3.1512C12.3142 2.61977 11.8649 2.18896 11.3107 2.18896Z",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4894 3.93848H4.10352V10.0618H10.4894V3.93848Z",
    stroke: "#6A82D2",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18558_13177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5962,
    height: 13.9961,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputepic);
export default __webpack_public_path__ + "static/media/computepic.8b791433b75066bad7bcc2a7ccb93a6b.svg";
export { ForwardRef as ReactComponent };